<script>
export default {
  name: 'IconDepartments',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
    internalColor: {
      type: String,
      default: '#fff',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="6" y="6" width="11" height="11" fill="#030309" />
    <path
      d="M18.5408 4.17001L13.0408 2.11001C12.4708 1.90001 11.5408 1.90001 10.9708 2.11001L5.47078 4.17001C4.41078 4.57001 3.55078 5.81001 3.55078 6.94001V15.04C3.55078 15.85 4.08078 16.92 4.73078 17.4L10.2308 21.51C11.2008 22.24 12.7908 22.24 13.7608 21.51L19.2608 17.4C19.9108 16.91 20.4408 15.85 20.4408 15.04V6.94001C20.4508 5.81001 19.5908 4.57001 18.5408 4.17001ZM12.0008 16.25C9.38078 16.25 7.25078 14.12 7.25078 11.5C7.25078 8.88001 9.38078 6.75001 12.0008 6.75001C14.6208 6.75001 16.7508 8.88001 16.7508 11.5C16.7508 14.12 14.6208 16.25 12.0008 16.25Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.999 15.6667H7.999C7.63167 15.6667 7.33233 15.368 7.33233 15V11.6667H8.66567V13.6667C8.66567 14.0353 8.96433 14.3333 9.33233 14.3333H14.6657C15.0337 14.3333 15.3323 14.0353 15.3323 13.6667V11.6667H16.6657V15C16.6657 15.368 16.3663 15.6667 15.999 15.6667ZM9.56119 6.702C9.67453 6.47467 9.90319 6.33334 10.1572 6.33334H13.8425C14.0965 6.33334 14.3252 6.47467 14.4385 6.702L16.2545 10.3333H14.6665C14.2985 10.3333 13.9999 10.6313 13.9999 11V13H9.99986V11C9.99986 10.6313 9.70119 10.3333 9.33319 10.3333H7.74519L9.56119 6.702ZM17.8593 10.5613L15.6313 6.10533C15.2907 5.424 14.6053 5 13.8427 5H10.1573C9.39467 5 8.70933 5.424 8.36867 6.10533L6.14067 10.5613C6.04867 10.7453 6 10.952 6 11.1573V15C6 16.1027 6.89733 17 8 17H16C17.1027 17 18 16.1027 18 15V11.1573C18 10.952 17.9513 10.7453 17.8593 10.5613Z"
      :fill="internalColor"
    />
  </svg>
</template>
